import { agendamentoOnlineAuthenticationMiddleware } from "@/router/middlewares";
import { getNameAliasRoute } from '@/router/utils';

var nomeRotaComAlias = getNameAliasRoute();
if (nomeRotaComAlias == "") nomeRotaComAlias = "--semloja--";

const routes = [
    {
      path: "/AdminSemPermissao",
      name: "AdminSemPermissao",
      component: () => import("@/views/Usuario43SemPermissao.vue"),
      meta: {
        title: "Sem permissão",
      },
    },
    {
      path: '/Loading',
      name: "Loading",
      component: () => import('@/views/Loading.vue'),
      meta: {
        title: 'Página não encontrada'
      }
    },
    {
      path: '/BrowserNaoSuportado',
      name: 'BrowserNaoSuportado',
      component: () => import('@/views/BrowserNaoSuportado.vue'),
      meta: {
        title: 'Navegador não suportado'
      }
    },
    {
      path: '*',
      name: "NotFound",
      component: () => import('@/views/Pagina404.vue'),
      meta: {
        title: 'Página não encontrada'
      }
    },
    {
      path: "/:alias",
      name: "HomeAgendamentoOnline",
      component: () => import('@/components/AgendamentoOnline/RouterContainer.vue'),
      beforeEnter: agendamentoOnlineAuthenticationMiddleware,
      meta: {
        title: "Agendamento Online"
      },
      children: [
        {
          path: `/${nomeRotaComAlias}`,
          name: `${nomeRotaComAlias}`,
          component: () => import('@/components/AgendamentoOnline/Home.vue'),
          meta: {
            exigirLogin: true,
          },
        },
        {
          path: `/${nomeRotaComAlias}/Home`,
          name: `${nomeRotaComAlias}Home`,
          component: () => import('@/components/AgendamentoOnline/Home.vue'),
          meta: {
            exigirLogin: true,
          },
        },
        {
          path: `/${nomeRotaComAlias}/Login`,
          name: `${nomeRotaComAlias}Login`,
          component: () => import('@/components/AgendamentoOnline/Login.vue'),
        },
        {
          path: `/${nomeRotaComAlias}/SemPermissao`,
          name: `${nomeRotaComAlias}SemPermissao`,
          component: () => import('@/views/AgendaOnlineSemPermissao.vue'),
        },
        {
          path: `/${nomeRotaComAlias}/MeusAgendamentos`,
          name: `${nomeRotaComAlias}MeusAgendamentos`,
          component: () => import('@/components/AgendamentoOnline/MeusAgendamentos.vue'),
          meta: {
            exigirLogin: true,
          },
        },
        {
          path: `/${nomeRotaComAlias}/Agendamento`,
          name: `${nomeRotaComAlias}Agendamento`,
          component: () => import('@/components/AgendamentoOnline/Agendamento.vue'),
          props: true,
        },
        {
          path: `/${nomeRotaComAlias}/SelecionaEmpresa`,
          name: `${nomeRotaComAlias}SelecionaEmpresa`,
          component: () => import('@/components/AgendamentoOnline/SelecionaEmpresa.vue'),
          props: true,
        },
      ],
    },
  ];

export default routes;
